import React, { useState } from 'react';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { UserType } from 'models/user.model';
import { apiService } from 'utils/api';
import { getUserName } from 'utils/functions';

const DeleteManagerFooter = ({
  onCancel,
  onConfirm,
  loading
}: {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
}) => {
  return (
    <div className='grid grid-cols-2 gap-x-4'>
      <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
        Cancel
      </Button>
      <Button
        small
        color='primary'
        variant='block'
        className='mx-auto'
        loading={loading}
        onClick={onConfirm}>
        Confirm
      </Button>
    </div>
  );
};
const DeleteManagerModal = ({
  show,
  onClose,
  manager
}: {
  show: boolean;
  onClose: () => void;
  manager: UserType;
}) => {
  const [loading, setLoading] = useState(false);
  const deleteManager = async () => {
    setLoading(true);
    const res = await apiService.delete(`logistics/super-admin/rider/${manager?.id}`);
    if (res) onClose();
  };
  return (
    <BaseModal
      isOpen={show}
      title='Delete Manager'
      titleIcon={<DeleteIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={
        <DeleteManagerFooter loading={loading} onCancel={onClose} onConfirm={deleteManager} />
      }>
      <p>Are you sure you want to remove {getUserName(manager)} permanently?</p>
    </BaseModal>
  );
};

export default DeleteManagerModal;
